const ALPHABET = '0123456789ABCDEFGHJKMNPQRSTVWXYZ'

type RandomBytes = (length: number) => Uint8Array

const cryptoBytes: RandomBytes = (length) => crypto.getRandomValues(new Uint8Array(length))

// newAppointmentId returns "apt_" + a ULID: 10 characters of millisecond time
// and 16 of randomness, the shape the API's ids.New("apt") makes. The app
// creates booking ids itself so a retried save can never book twice.
export function newAppointmentId(now: number = Date.now(), randomBytes: RandomBytes = cryptoBytes): string {
  return newId('apt', now, randomBytes)
}

// newTimeBlockId is the same for a time block ("tbk_"), so a retried save
// can never block twice.
export function newTimeBlockId(now: number = Date.now(), randomBytes: RandomBytes = cryptoBytes): string {
  return newId('tbk', now, randomBytes)
}

function newId(prefix: string, now: number, randomBytes: RandomBytes): string {
  let time = ''
  let t = now
  for (let i = 0; i < 10; i++) {
    time = ALPHABET[t % 32] + time
    t = Math.floor(t / 32)
  }

  let random = ''
  let buffer = 0
  let bits = 0
  for (const byte of randomBytes(10)) {
    buffer = (buffer << 8) | byte
    bits += 8
    while (bits >= 5) {
      random += ALPHABET[(buffer >> (bits - 5)) & 31]
      bits -= 5
    }
    buffer &= (1 << bits) - 1
  }
  return `${prefix}_${time}${random}`
}
